import { render } from "./PriceBox.vue?vue&type=template&id=583c8c74&scoped=true"
import script from "./PriceBox.vue?vue&type=script&lang=js"
export * from "./PriceBox.vue?vue&type=script&lang=js"

import "./PriceBox.vue?vue&type=style&index=0&id=583c8c74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583c8c74"]])

export default __exports__